import { forwardRef } from 'react';
import { FaCalendar } from 'react-icons/fa';

const formatToISO = (d) => {
  if (!d) return undefined;
  const date = d instanceof Date ? d : new Date(d);
  if (Number.isNaN(date.getTime())) return undefined;
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const dd = String(date.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

const CustomInput = forwardRef(({ value, onClick, handleClick, minDate, maxDate }, ref) => {
  const clickHandler = onClick || handleClick || (() => {});
  const minISO = formatToISO(minDate);
  const maxISO = formatToISO(maxDate);

  return (
    <button
      type="button"
      className="custom-input"
      onClick={clickHandler}
      ref={ref}
      aria-label="Seleccionar fecha"
      style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0, cursor: 'pointer' }}
    >
      <input
        value={value ?? ''}
        readOnly
        className="widthCalendar"
        data-tooltip-id="tooltiparriba"
        data-tooltip-content="Seleccione fecha"
        tabIndex={-1}
        // add min/max both as attributes and data-attributes (format ISO yyyy-mm-dd)
        min={minISO}
        max={maxISO}
        data-mindate={minISO}
        data-maxdate={maxISO}
        aria-valuemin={minISO}
        aria-valuemax={maxISO}
        style={{ pointerEvents: 'none', background: 'transparent', border: 'none', width: 'auto' }}
      />
      <FaCalendar />
    </button>
  );
});

export default CustomInput;
